import {useQuery, gql} from 'admin/lib/apollo'

export const GET_SCHEDULE = gql`
  query GetSchedule($accountId: ID!) {
    schedule(accountId: $accountId) {
      ... on Invoice {
        id
        date
        amount
        description @client
        isSendable
        isSent
        state
      }
      ... on RepeatingInvoice {
        id
        nextInvoiceDate
        frequency
        frequencyCount
        amount
        description @client
        isSendable
        state
        endDate
      }
    }
  }
`

export default (organisationId, accountId) => {
  const {data: {schedule = []} = {}} = useQuery(GET_SCHEDULE, {variables: {organisationId, accountId}})
  return {schedule}
}
